import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.fill.js";
export var empty = function empty(numProducts) {
  return Array(numProducts).fill().map(function (value, counter) {
    return counter;
  });
};